import { render, staticRenderFns } from "./_OverviewSupplierBlock.vue?vue&type=template&id=1e2720d3"
import script from "./_OverviewSupplierBlock.vue?vue&type=script&lang=js"
export * from "./_OverviewSupplierBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports